import { RevenueSource } from "entities/RevenueSource";
import React from "react";
import { useInput, useTranslate } from "react-admin";

import {
	FilterToggleButtonGroup,
	StyledToggleButton,
} from "../../../components/filters/FilterToggleInput";

export const RevenueSourceFilter = (props) => {
	const translate = useTranslate();
	const { input } = useInput({ ...props, defaultValue: RevenueSource.ALL });
	const value = input.value;

	const handleChange = (e, newValue) => {
		if (newValue === null) return;
		input.onChange(newValue);
	};

	return (
		<FilterToggleButtonGroup
			value={value}
			onChange={handleChange}
			label={input.label}
			exclusive
		>
			<StyledToggleButton value={RevenueSource.ORDERS}>
				{translate("osfc.filters.financial_statement.revenue_source.orders")}
			</StyledToggleButton>
			<StyledToggleButton value={RevenueSource.WEEKLY_STORAGE}>
				{translate("osfc.filters.financial_statement.revenue_source.weekly_storage")}
			</StyledToggleButton>
			<StyledToggleButton value={RevenueSource.ALL}>
				{translate("osfc.filters.financial_statement.revenue_source.all")}
			</StyledToggleButton>
		</FilterToggleButtonGroup>
	);
};
